<template>
  <div class="infoItem d-flex">
    <div class="status-img-wrap">
      <img
        class="status-img"
        :src="imgStatus"
        :class="{ red: item.status == 1 }"
      />
    </div>
    <span class="text label" v-if="item.scheduled">
      {{
        $t(
          epoch >= item.epoch1 ? item.scheduledLabel : item.label, {
          epoch1: item.epoch1,
          tax: item.fee_rate,
          epoch2: epoch,
        })
      }}
    </span>
    <span class="text label" v-else>
      <span>
        {{ $t(item.label, { tax: item.tax }) }}{{ item.tax ? '%' : '' }}
      </span>
      <span
        class="doubt-wrap"
        v-if="item.is_honeypot || (item.transfer_hook && transferHookList.length) || (item.metadata_mutable && addressList.length)"
      >
        <img
          class="doubt-img"
          :src="doubtImg"
          @click.stop="$emit('getToastTitle', { title: tipsText, short: false, metadata_mutable: item.metadata_mutable || item.transfer_hook })"
        />
        <div class="tip-text" v-if="!item.metadata_mutable && !item.transfer_hook">
          {{ tipsText }}
          <div class="triangle"></div>
        </div>
        <div
          class="tip-text"
          :class="{ 'metadata-mutable': item.metadata_mutable || item.transfer_hook }"
          v-else
        >
          <div>{{ tipsText }}</div>
          <ToastAddress v-if="item.metadata_mutable" :addressList="addressList"/>
          <ToastAddress v-if="item.transfer_hook" :addressList="transferHookList"/>
          <div class="triangle"></div>
        </div>
      </span>
    </span>
  </div>
</template>

<script>
import ToastAddress from "./ToastAddress.vue";
import { mapGetters } from 'vuex';
export default {
  props: {
    item: {
      type: Object,
    },
    epoch: {
      type: [Number, String],
    },
    addressList: {
      type: Array,
    },
    transferHookList: {
      type: Array,
    },
  },
  components: { ToastAddress },
  computed: {
    ...mapGetters(['isDark']),
    tipsText() {
      if (this.item) {
        if (this.item.is_honeypot) {
          return this.$t('is_honeypot');
        } else if (this.item.transfer_hook) {
          if (this.transferHookList.length > 0) {
            return this.$t('SOL.transfer_hook_1');
          } else {
            return this.$t('SOL.transfer_hook');
          }
        } else if (this.item.metadata_mutable) {
          return this.$t('SOL.metadata_mutable');
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    doubtImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      return require(`../assets/doubt${str}.png`);
    },
    imgStatus() {
      if (this.item?.status == 0) {
        return require('../assets/green.png');
      } else if (this.item?.status == 1) {
        return require('../assets/orange.png');
      } else {
        return require('../assets/red.png');
      }
    },
  },
  // mounted() {
  //   console.log('item', this.item);
  //   console.log('transferHookList', this.transferHookList);
  // },
};
</script>

<style lang="scss" scoped>
.infoItem {
  &:nth-child(n + 2) {
    margin-top: 0.12rem;
  }
  .status-img-wrap {
    height: 0.2rem;
    display: flex;
    align-items: center;
    .status-img {
      width: 0.15rem;
      height: 0.15rem;
    }
  }
  .doubt-wrap {
    position: relative;
    display: inline-flex;
    margin-left: 0.06rem;
    vertical-align: middle;
    .doubt-img {
      width: 0.12rem;
      height: 0.12rem;
      cursor: pointer;
    }
    .tip-text {
      display: none;
      &.metadata-mutable {
        display: none;
      }
      .triangle {
        border-top: 0.1rem solid var(--tip-bg);
      }
    }
  }
  .doubt-wrap:hover {
    .tip-text {
      display: block;
      background: var(--tip-bg);
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      &.metadata-mutable {
        display: flex;
        span {
          color: #ffffff;
        }
      }
    }
  }
  .red {
    width: 0.15rem;
    height: 0.15rem;
  }
  span {
    font-size: 0.14rem;
    color: var(--gray-10);
    // vertical-align: middle;
  }
  .label {
    margin-left: 0.1rem;
    line-height: 0.2rem;
    span {
      vertical-align: middle;
    }
  }
}
@media screen and (max-width: 767px) {
  .infoItem {
    &:nth-child(n + 2) {
      margin-top: 0.24rem;
    }
    .status-img-wrap {
      height: 0.4rem;
      .status-img {
        width: 0.36rem;
        height: 0.36rem;
      }
    }
    .doubt-wrap {
      position: relative;
      .doubt-img {
        width: 0.24rem;
        height: 0.24rem;
        cursor: pointer;
      }
      .tip-text {
        display: none;
      }
    }
    .doubt-wrap:hover {
      .tip-text {
        display: none;
        &.metadata-mutable {
          display: none;
        }
      }
    }
    .red {
      width: 0.38rem;
      height: 0.36rem;
    }
    span {
      font-size: 0.26rem;
    }
    .label {
      margin-left: 0.12rem;
      line-height: 0.4rem;
    }
  }
}
@media screen and (min-width: 767px) {
  .infoItem {
    .doubt-wrap {
      .doubt-img {
        pointer-events: none;
      }
    }
  }
}
</style>
